<div class="editor-page">
  <div class="container-xxl editor">
    <header class="editor-head">
      <div class="editor-banner">
        <img src="assets/img/contactBar.png" alt="">
        <h1>Impostazioni</h1>
      </div>
      <p class="editor-lead">Aggiorna i dati del profilo o cambia la password di accesso.</p>
    </header>

    <div class="settings-nav" role="tablist" aria-label="Sezioni impostazioni">
      <button type="button" role="tab" id="tab-general" [class.is-active]="activeTab === 'general'"
        [attr.aria-selected]="activeTab === 'general'" (click)="activeTab = 'general'">
        Generali
      </button>
      <button type="button" role="tab" id="tab-password" [class.is-active]="activeTab === 'password'"
        [attr.aria-selected]="activeTab === 'password'" (click)="activeTab = 'password'">
        Modifica password
      </button>
    </div>

    @if (activeTab === 'general') {
      <form class="editor-form" [formGroup]="generalForm">
        <section class="editor-panel" role="tabpanel" aria-labelledby="tab-general">
          <h2>Dati personali</h2>
          <div class="field-grid field-grid-2">
            <div class="field-block">
              <label for="name">Nome<sup>*</sup></label>
              <input id="name" class="field" type="text" formControlName="name" autocomplete="given-name"
                [class.is-invalid]="generalForm.get('name')?.invalid && (submittedGeneral || generalForm.get('name')?.dirty)">
            </div>
            <div class="field-block">
              <label for="surname">Cognome<sup>*</sup></label>
              <input id="surname" class="field" type="text" formControlName="surname" autocomplete="family-name"
                [class.is-invalid]="generalForm.get('surname')?.invalid && (submittedGeneral || generalForm.get('surname')?.dirty)">
            </div>
          </div>
          <div class="field-block email-block">
            <label for="email">Email</label>
            <input id="email" class="field" type="email" formControlName="email" autocomplete="email">
            <p class="field-hint">L'indirizzo email non può essere modificato.</p>
          </div>
        </section>

        <div class="editor-actions">
          @if (generalForm.invalid && submittedGeneral) {
            <p class="editor-hint">Compila correttamente tutti i campi per abilitare il salvataggio.</p>
          }
          <button class="editor-save" type="button" (click)="updateGeneral()">Salva</button>
        </div>
      </form>
    } @else {
      <form class="editor-form" [formGroup]="modifyPasswordForm">
        <section class="editor-panel" role="tabpanel" aria-labelledby="tab-password">
          <h2>Password</h2>
          <div class="field-stack">
            <div class="field-block">
              <label for="password1">Password attuale<sup>*</sup></label>
              <div class="password-field">
                <input id="password1" class="field" [type]="type1" formControlName="current_password"
                  autocomplete="current-password"
                  [class.is-invalid]="modifyPasswordForm.get('current_password')?.invalid && (modifyPasswordForm.get('current_password')?.dirty || submittedPassword)">
                <button class="password-toggle" type="button" (click)="seePassword('password1')"
                  [attr.aria-label]="toggled1 ? 'Mostra password attuale' : 'Nascondi password attuale'">
                  <i class="bi" [class.bi-eye]="toggled1" [class.bi-eye-slash]="!toggled1" aria-hidden="true"></i>
                </button>
              </div>
            </div>

            <div class="field-block">
              <label for="password2">Nuova password<sup>*</sup></label>
              <div class="password-field">
                <input id="password2" class="field" [type]="type2" formControlName="password" autocomplete="new-password"
                  (input)="checkPassword()"
                  [class.is-invalid]="modifyPasswordForm.get('password')?.invalid && (submittedPassword || modifyPasswordForm.get('password')?.dirty)">
                <button class="password-toggle" type="button" (click)="seePassword('password2')"
                  [attr.aria-label]="toggled2 ? 'Mostra nuova password' : 'Nascondi nuova password'">
                  <i class="bi" [class.bi-eye]="toggled2" [class.bi-eye-slash]="!toggled2" aria-hidden="true"></i>
                </button>
              </div>
              @if (errorMessage && !validPassword) {
                <p class="field-error">La password deve essere lunga almeno 8 caratteri, contenere una maiuscola e un simbolo speciale.</p>
              }
            </div>

            <div class="field-block">
              <label for="password3">Ripeti password<sup>*</sup></label>
              <div class="password-field">
                <input id="password3" class="field" [type]="type3" formControlName="password_confirmation"
                  autocomplete="new-password" (input)="checkPassword()"
                  [class.is-invalid]="modifyPasswordForm.get('password_confirmation')?.invalid && (modifyPasswordForm.get('password_confirmation')?.dirty || submittedPassword)">
                <button class="password-toggle" type="button" (click)="seePassword('password3')"
                  [attr.aria-label]="toggled3 ? 'Mostra conferma password' : 'Nascondi conferma password'">
                  <i class="bi" [class.bi-eye]="toggled3" [class.bi-eye-slash]="!toggled3" aria-hidden="true"></i>
                </button>
              </div>
              @if (errorMessage && !equalPassword) {
                <p class="field-error">Le due password sono differenti.</p>
              }
            </div>
          </div>
        </section>

        <div class="editor-actions">
          @if (modifyPasswordForm.invalid && submittedPassword) {
            <p class="editor-hint">Compila correttamente tutti i campi per abilitare il salvataggio.</p>
          }
          <button class="editor-save" type="button" (click)="saveNewPassword()">Salva</button>
        </div>
      </form>
    }
  </div>
</div>
